import styled from 'styled-components';
import { MainTitle } from '@src/theme/commonElements';
export const BoldTitle = styled(MainTitle) `
  font-weight: ${({ theme }) => theme.typography.fontWeight[600]};
`;
